import {Injectable} from '@angular/core';
import {
    AbstractDataServiceDtoAdapter
} from '../../../../../../core/service/v2/dataservice/adapter/abstractDataServiceDto.adapter';
import {MedicalRecordSportModel} from '../../../api/model/medicalRecordSport.model';
import {MedicalRecordSportConverter} from '../../../api/converter/medicalRecordSport.converter';
import {MedicalSportDataService} from './medicalSportData.service';

@Injectable({providedIn: 'root'})
export class MedicalSportDataServiceAdapter
    extends AbstractDataServiceDtoAdapter<MedicalRecordSportModel, MedicalRecordSportConverter> {
    constructor(dataService: MedicalSportDataService, converter: MedicalRecordSportConverter) {
        super(dataService, converter);
    }
    newStoredEntityInstance(): MedicalRecordSportModel {
        return new MedicalRecordSportModel();
    }
}
